import React from 'react';
import { useDataContext } from '../../data/DataContext';
import PersonIcon from '@mui/icons-material/Person';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

interface UserProps {
    name: string;
    email: string;
}

function User({ name, email }: UserProps) {
    const { isInAdminMode } = useDataContext(); 

    return (
      <div className="user">
        {isInAdminMode ? (
          <ManageAccountsIcon className='icon' />
        ) : (
          <PersonIcon className='icon' />
        )}
        <p className="name">{name}</p>
        <p className="email">{email}</p>
      </div>
    );
}

export default User;